var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _ellipse, _ellipse2, _path3, _rect9, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreePlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 109,
    viewBox: "0 0 144 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 141,
    height: 106,
    rx: 7.5,
    fill: "white",
    stroke: "#EFF5FA",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 4.85787 4.85786 1.5 9 1.5H37.5V107.5H9C4.85786 107.5 1.5 104.142 1.5 100V9Z",
    fill: "white",
    stroke: "#EFF5FA",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5H135C139.142 1.5 142.5 4.85786 142.5 9V31.5H1.5V9Z",
    fill: "white",
    stroke: "#EFF5FA",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 42,
    width: 21,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 50,
    width: 21,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 58,
    width: 21,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 66,
    width: 16,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 41,
    width: 78,
    height: 6,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 67,
    width: 45,
    height: 6,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 54,
    width: 78,
    height: 6,
    rx: 1,
    fill: "#EFF5FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 16.5,
    rx: 8,
    ry: 8.5,
    fill: "#CAE6FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 13.78,
    rx: 2.88,
    ry: 3.06,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.133 22.2787C120.836 19.5364 123.196 17.52 126 17.52C128.804 17.52 131.164 19.5363 131.867 22.2786C130.406 23.9525 128.318 25 126 25C123.682 25 121.594 23.9525 120.133 22.2787Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 14,
    width: 68,
    height: 5,
    rx: 1,
    fill: "#EBF5FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 25H17.5L17.4986 21.6019L26 8H9V25Z",
    fill: "#5CCEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 25H16.4643L12.8888 19.2343L18.94 13.6666L26 25Z",
    fill: "#4D94FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8474 12.25H17.6755C18.5307 12.25 19.3509 12.5897 19.9556 13.1944C20.5603 13.7992 20.9 14.6193 20.9 15.4745V20.3026C20.9 20.5497 20.6997 20.75 20.4526 20.75H15.6245C14.7693 20.75 13.9492 20.4103 13.3445 19.8056C12.7397 19.2008 12.4 18.3807 12.4 17.5255V12.6974C12.4 12.4503 12.6003 12.25 12.8474 12.25Z",
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.525 13.95H18.775V15.1886H17.3461V19.05H15.9539V15.1886H14.525V13.95Z",
    fill: "#4D94FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlan);
export default __webpack_public_path__ + "static/media/free-plan.e29bc6615ace35284b02dfe21f59fdad.svg";
export { ForwardRef as ReactComponent };